import { useNavigate } from "react-router-dom";
import { IoChevronDown, IoArrowBack } from "react-icons/io5";

const PHOTOS = [
    { id: 1, src: "https://picsum.photos/seed/friends/400/500", alt: "Friends connecting" },
    { id: 2, src: "https://picsum.photos/seed/street/400/300", alt: "Community street art" },
    { id: 3, src: "https://picsum.photos/seed/night/400/380", alt: "Person reflecting at night" },
    { id: 4, src: "https://picsum.photos/seed/cafe/400/300", alt: "Person at coffee shop" },
];

export default function WhyWeExist() {
    const navigate = useNavigate();

    return (
        <div className="relative flex h-full w-full flex-col overflow-hidden">
            {/* Back arrow — mobile only */}
            <button
                onClick={() => navigate(-1)}
                className="flex md:hidden items-center gap-1.5 px-4 pt-4"
            >
                <IoArrowBack className="text-[22px]" />
            </button>

            <div className="flex flex-1 items-start gap-8 overflow-y-auto px-6 py-6 md:px-10 md:py-10 lg:px-14 no-scrollbar">

                {/* Left — text */}
                <div className="flex w-full max-w-[450px] shrink-0 flex-col pt-2">
                    {/* Badge */}
                    <div className="mb-6 w-fit rounded-xl border border-[#5BA9DC] px-4 py-2">
                        <span className="text-[15px] font-semibold text-[#2E9DDA]">Why we built this</span>
                    </div>

                    <h1 className="text-[36px] font-black leading-[1.18] text-black lg:text-[40px]">
                        Social media lost its purpose.
                    </h1>

                    <div className="mt-6 space-y-4 text-[16px] font-medium leading-[1.7] text-[#393939]">
                        <p>
                            We've all felt it—the endless scrolling, the pressure to keep up,
                            the sense that something is missing.
                        </p>
                        <p>
                            Social platforms today are optimized for attention, not connection.
                            And over time, that's made it harder to feel truly seen or heard.
                        </p>
                        <p>
                            We believe it doesn't have to be this way. That's why we're
                            creating a platform where people can slow down, connect more
                            intentionally, and feel part of something real.
                        </p>
                    </div>
                </div>

                {/* Right — staggered 2-column photo grid */}
                <div className="hidden shrink-0 md:flex gap-3 mt-10">
                    {/* Left column — aligned to top */}
                    <div className="flex flex-col gap-3">
                        <img
                            src={PHOTOS[0].src}
                            alt={PHOTOS[0].alt}
                            className="h-[255px] w-[180px] rounded-2xl object-cover"
                            draggable={false}
                        />
                        <img
                            src={PHOTOS[2].src}
                            alt={PHOTOS[2].alt}
                            className="h-[255px] w-[180px] rounded-2xl object-cover"
                            draggable={false}
                        />
                    </div>
                    {/* Right column — shifted down to create stagger */}
                    <div className="flex flex-col gap-3 mt-14">
                        <img
                            src={PHOTOS[1].src}
                            alt={PHOTOS[1].alt}
                            className="h-[255px] w-[180px] rounded-2xl object-cover"
                            draggable={false}
                        />
                        <img
                            src={PHOTOS[3].src}
                            alt={PHOTOS[3].alt}
                            className="h-[255px] w-[180px] rounded-2xl object-cover"
                            draggable={false}
                        />
                    </div>
                </div>
            </div>

            {/* Bottom — next page nav */}
            <div className="flex items-center justify-center pb-6">
                <button
                    onClick={() => navigate("/about-us/what-makes-us-different")}
                    className="flex items-center gap-1.5 text-[14px] font-semibold text-[#2E9DDA] hover:underline"
                >
                    What makes us different
                    <IoChevronDown className="text-[15px]" />
                </button>
            </div>
        </div>
    );
}
